import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

import { filterBoolean } from '@core/common-legacy';
import type { Requisition } from '@core/requisitions-types';
import type { AssignedJob } from '@recruitee/requisitions-data';
import { AssignedJobsSelectors } from '@recruitee/requisitions-data';

import { RootPageDataService } from './root-page-data.service';

@Injectable()
export class JobsPageDataService {
  private readonly rootData = inject(RootPageDataService);
  private readonly store = inject(Store);

  public requisition$: Observable<Requisition>;
  public jobs$: Observable<AssignedJob[]>;
  public isLoaded$: Observable<boolean>;

  constructor() {
    const rootData = this.rootData;
    const store = this.store;

    this.requisition$ = rootData.requisition$;
    const requisitionId$ = this.requisition$.pipe(map(requisition => requisition.id));
    this.jobs$ = requisitionId$
      .pipe(switchMap(id => store.select(AssignedJobsSelectors.byId(id))))
      .pipe(filterBoolean);
    this.isLoaded$ = requisitionId$.pipe(
      switchMap(id => store.select(AssignedJobsSelectors.isLoaded(id))),
    );
  }
}
